$(document).ready(function () {
    $(".reviews-slider").not('.slick-initialized').slick({
        infinite: true,
        lazyLoad: 'ondemand',
        speed: 500,
        dots: true,
        arrows: true,
        cssEase: "linear",
        prevArrow: `<div class="arrow-prew"><svg width="7" height="14" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.5 1.229L1.50024 8.22876L8.5 15.2285" stroke="#333333" stroke-linecap="round"/>
        </svg></div>`,
        nextArrow: `<div class="arrow-next"><svg width="7" height="14" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 1.229L7.49976 8.22876L0.5 15.2285" stroke="#333333" stroke-linecap="round"/>
        </svg></div>`,
    });
    $(".good-page-img").not('.slick-initialized').slick({
        infinite: false,
        speed: 500,
        dots: false,
        arrows: false,
        cssEase: "linear",
        asNavFor: '.good-page-gallery-img',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: true
                }
            },
        ]

    });
    $(".good-page-gallery-img").not('.slick-initialized').slick({
        vertical: true,
        verticalSwiping: true,
        infinite: false,
        // speed: 500,
        dots: false,
        arrows: false,
        // cssEase: "linear",
        asNavFor: '.good-page-img',
        slidesToShow: 6,
        slidesToScroll: 1,
        focusOnSelect: true,
    });
    //     $(".gallery-item-link").magnificPopup({
    //       type: "image",
    //       gallery: {
    //           enabled: true,
    //       },
    //   });
    $(".addition_gallery").not('.slick-initialized').slick({
        infinite: false,
        speed: 500,
        cssEase: "linear",
        asNavFor: '.addition_gallery-item',
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });
    // $(".addition_gallery-item").magnificPopup({
    //     type: "image",
    //     gallery: {
    //         enabled: true,
    //     },
    // });
})